import React, { useEffect, useState } from 'react'
import AddModalMoreButton from '../../../buttons/AddModalMoreButton'
import { mainSearchApiHandler } from '../../../../functions/SearchApi'
import SearchInput from '../../../inputs/SearchInput'
import RangeDatePickerInput from '../../../inputs/RangeDatePickerInput'

function SearchBox({
  customers,
  setIsSearch,
  setLazyLoadData,
  lazy_load_data,
  searchResult,
  is_all_items_load,
  setAllLoad,
  car_models,
  customer_types,
  cars,
  setCars,
  setSelectedPeriod,
  setPropsSearchValue,
}) {
  const [search_value, setSearchValue] = useState('')
  const [period, setPeriod] = useState([])

  const inputHandler = async (e) => {
    setSearchValue(e.target.value)
    setPropsSearchValue(e.target.value)
    if (e.target.value.length === 0) {
      searchResult([NaN, NaN])
      await mainSearchApiHandler(
        null,
        setAllLoad,
        is_all_items_load,
        lazy_load_data,
        setLazyLoadData,
        setIsSearch,
        setCars,
        searchResult
      )
    }
  }

  const submitSearch = async (e) => {
    e.preventDefault()
    searchResult([NaN, NaN])
    await mainSearchApiHandler(
      search_value,
      is_all_items_load,
      lazy_load_data,
      setLazyLoadData,
      setIsSearch,
      setCars,
      searchResult,
      period
    )
  }

  useEffect(() => {
    async function fetchData() {
      await mainSearchApiHandler(
        search_value,
        is_all_items_load,
        lazy_load_data,
        setLazyLoadData,
        setIsSearch,
        setCars,
        searchResult,
        period
      )
      setSelectedPeriod(period)
    }
    fetchData()
  }, [period])

  return (
    <div
      className={
        'bg-light-blue dark:bg-slate-800 dark:border-gray-700 dark:shadow-none py-4 sm:py-9 px-3 sm:px-8 w-full rounded-2xl border border-light-gray shadow-info-count block'
      }
    >
      <div className="grid sm:grid-cols-3 gap-6">
        <form className="flex items-center justify-center" onSubmit={submitSearch}>
          <SearchInput
            isNumber={true}
            search_value={search_value}
            inputHandler={inputHandler}
            placeholder={'کد خودرو یا شماره تماس'}
          />
        </form>

        <RangeDatePickerInput setPeriod={setPeriod} />

        <AddModalMoreButton
          customers={customers}
          cars={cars}
          setCars={setCars}
          customer_types={customer_types}
          car_models={car_models}
        />
      </div>
    </div>
  )
}

export default SearchBox
